import PropTypes from "prop-types";
import { childrenPropType, onClosePropType, classNamePropType } from "../../common";

/**
 * PropTypes for Modal component
 *
 * @property {boolean} isOpen - Whether modal should be displayed
 * @property {('small'|'medium'|'large')} [width] - Modal width preset
 * @property {('outside'|'')} [scrollBehavior] - Scroll behavior: "outside" for scrolling outside modal
 * @property {function} onClose - Callback fired when modal should close
 * @property {React.ReactNode} children - Modal content (ModalHeader, ModalBody, ModalFooter components)
 * @property {string} [className] - Additional CSS classes for modal content
 */
export const modalPropTypes = {
  isOpen: PropTypes.bool.isRequired,
  width: PropTypes.oneOf(["small", "medium", "large"]),
  scrollBehavior: PropTypes.oneOf(["outside", ""]),
  onClose: onClosePropType.isRequired,
  children: childrenPropType,
  className: classNamePropType,
};

/**
 * PropTypes for ModalDialogContent internal component
 *
 * @property {React.ReactNode} children - Modal content
 * @property {('small'|'medium'|'large')} [width] - Modal width preset
 * @property {function} [onClose] - Close handler
 * @property {('outside'|'')} [scrollBehavior] - Scroll behavior
 * @property {string} [className] - Extra classes
 */
export const modalDialogContentPropTypes = {
  children: childrenPropType,
  width: PropTypes.oneOf(["small", "medium", "large"]),
  onClose: onClosePropType,
  scrollBehavior: PropTypes.oneOf(["outside", ""]),
  className: classNamePropType,
};

/**
 * PropTypes for ModalHeader component
 *
 * @property {React.ReactNode} children - Header title text or content
 * @property {function} [onClose] - Callback to close modal (auto-provided by Modal)
 */
export const modalHeaderPropTypes = {
  children: childrenPropType,
  onClose: onClosePropType,
};

/**
 * PropTypes for ModalBody component
 *
 * @property {React.ReactNode} children - Body content
 */
export const modalBodyPropTypes = {
  children: childrenPropType,
};

/**
 * PropTypes for ModalFooter component
 *
 * @property {React.ReactNode} children - Footer content (typically buttons)
 */
export const modalFooterPropTypes = {
  children: childrenPropType,
};
